import { Flex, CheckboxGroup, Spinner, TextInput, DatePicker } from '@applyboard/crystal-ui';
import { ConditionType, useOfferConditions } from '../../../../data/useOfferConditions';

export function ConditionGroup(props: {
  conditionType: ConditionType;
  setConditions: (conditions: Array<string>) => void;
  conditions: Array<string>;
  setCustomCondition: (condition: string) => void;
  customCondition: string;
  enableConditionDeadline: boolean;
  conditionDeadline?: string;
  setConditionDeadline?: (date: string) => void;
}) {
  const { conditions: remoteConditions, isFetchingCondition } = useOfferConditions(props.conditionType);
  const minDate = new Date();
  minDate.setDate(minDate.getDate() - 1);

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 15);

  if (isFetchingCondition) {
    return (
      <Flex direction="column" align="center">
        <Flex>
          <Spinner />
        </Flex>
      </Flex>
    );
  }

  return (
    <>
      <CheckboxGroup
        onChange={(conditions: Array<string>) => {
          props.setConditions(conditions);
        }}
        value={props.conditions}
        label="You can optionally choose one or more conditions so the student can be accepted in the program."
      >
        <Flex direction="column">
          {remoteConditions?.map((i) => (
            <CheckboxGroup.Option label={i.name} value={i.code} key={i.id} aria-label={i.name} />
          ))}
        </Flex>
      </CheckboxGroup>
      <TextInput
        label="Custom condition"
        intent="secondary"
        onChange={(condition: string) => props.setCustomCondition(condition)}
        value={props.customCondition}
        helpText="Add any conditions that are not included in the list above"
        aria-label="Custom condition"
      />
      {props.enableConditionDeadline && (
        <DatePicker
          granularity="day"
          label="Condition Deadline"
          maxDate={maxDate.toISOString()}
          minDate={minDate.toISOString()}
          onChange={(date: string) => props.setConditionDeadline && props.setConditionDeadline(date)}
          size="md"
          value={props.conditionDeadline ? props.conditionDeadline : ''}
          aria-label="Condition Deadline"
        />
      )}
    </>
  );
}
